<div class="h-full md:h-5/6 w-full">
    <div class="w-full justify-center flex">
        <mat-card class="login-container">
            @if (hasBackNavigationButton()) {
                <a
                    class="w-fit"
                    color="primary"
                    mat-button
                    [routerLink]="['/', RoutePathEnum.LOGIN]">
                    <fa-icon
                        class="mr-2"
                        [icon]="['far', 'arrow-left']" />
                    {{ 'back' | transloco }}
                </a>
            }
            <div class="text-headline-3">
                {{ 'welcomeOn' | transloco }} Connect<span class="text-tertiary">Services</span>
            </div>
            <p class="text-headline-6 text-on-surface">
                {{ subtitleI18NKey() | transloco }}
            </p>
            <ng-content />
        </mat-card>
        <ng-content select="[outside-login-container]" />
    </div>
</div>
